import { render } from "./NotFound.vue?vue&type=template&id=6a107ed3"
const script = {}

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__